import { useSelector } from 'react-redux';
import {
  useQuery,
  DocumentNode,
  ApolloError,
  ApolloQueryResult,
  OperationVariables,
} from '@apollo/client';
import { RootState } from '../../../../store/store';
import { Customer } from '../../../../types/schema/customer.types';
import { PaginationWSearchInput } from '../../../../types/schema/utils.types';

interface GetAllCustomersBySearchByPageHook {
  data: Customer[] | undefined;
  loading: boolean;
  error: ApolloError | undefined;
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      getAllCustomersBySearchByPage: Customer[];
    }>
  >;
}

interface GetAllCustomersBySearchByPageMutationData {
  getAllCustomersBySearchByPage: Customer[];
}

interface GetAllCustomersBySearchByPageInputType {
  input: PaginationWSearchInput;
}

export function useGetAllCustomersBySearchByPage(
  query: DocumentNode,
  input: PaginationWSearchInput
): GetAllCustomersBySearchByPageHook {
  const { jwt } = useSelector((state: RootState) => state.auth);

  const { data, loading, error, refetch } = useQuery<
    GetAllCustomersBySearchByPageMutationData,
    GetAllCustomersBySearchByPageInputType
  >(query, {
    variables: {
      input,
    },
    context: {
      headers: {
        cookie: `jwt=${jwt}`,
        authorization: jwt ? `Bearer ${jwt}` : '',
      },
    },
  });

  return {
    data: data?.getAllCustomersBySearchByPage,
    loading,
    error,
    refetch,
  };
}
